<div class="modal-container">
  <div class="modal-header-block">
    <div class="modal-title">Key Changes</div>
    <button type="button" class="icon-button close-button" aria-label="Close" (click)="bsModalRef.hide()">
      &times;
    </button>
  </div>


  <h5 class="key-heading" *ngIf="issueName">
    {{ issueName }}
  </h5>


  <div class="modal-body-block">

    <div class="table-wrapper" role="region" aria-label="Key changes table">
      <table class="changes-table">
        <thead>
          <tr>
            <th scope="col">Field</th>
            <th scope="col">Old</th>
            <th scope="col">New</th>
          </tr>
        </thead>
        <tbody>
          <!-- Loading -->
          <tr *ngIf="logsLoading">
            <td colspan="3">Loading logs…</td>
          </tr>

          <!-- Error -->
          <tr *ngIf="!logsLoading && logsError">
            <td colspan="3" class="error">{{ logsError }}</td>
          </tr>

          <!-- Empty -->
          <tr *ngIf="!logsLoading && !logsError && latestChanges.length === 0">
            <td colspan="3">No changes found.</td>
          </tr>

          <!-- Data rows -->
          <tr *ngFor="let row of latestChanges; trackBy: trackByField"
            title="Last updated: {{ row.updatedDate | date:'medium' }} by {{ row.updatedBy || 'N/A' }}">
            <!-- <td class="field-name">{{ row.field }}</td> -->
             <td class="field-name" [innerHTML]="row.field"></td>
            <!-- <td class="cell-before">{{ row.before ?? '—' }}</td>
              <td class="cell-after">{{ row.after ?? '—' }}</td> -->

            <td class="cell-before">
              {{ row.before && row.before.toString().trim() ? row.before : '—' }}
            </td>

            <td class="cell-after">
              {{ row.after && row.after.toString().trim() ? row.after : '—' }}
            </td>

          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>